import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RichTextEditor from 'Components/UI/RichTextEditor';
import { config } from 'Components/ComponentLibrary/Components/Uncategorized/RichTextEditorInputField/config';
import { noop } from 'Helpers/PropTypes';
import {
  RichTextEditorInputFieldSkeleton,
} from 'Components/ComponentLibrary/Components/Uncategorized/RichTextEditorInputField/components/RichTextEditorInputFieldSkeleton';

const useStyles = buildUseStyles('RichTextEditorInputField', (theme) => ({
  root: {
    paddingTop: theme.spacing(1),
  },
  hidden: {
    display: 'none',
  },
}));


const RichTextEditorInputField = ({
  className,
  onChange,
  onLoaded,
  value,
  disabled,
  rounded,
  customConfig,
  borderless,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [loading, setLoading] = useState(true);
  const editorRef = useRef();

  const handleLoaded = () => {
    setLoading(false);
    onLoaded();
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {loading && <RichTextEditorInputFieldSkeleton height={customConfig?.height} />}
      <RichTextEditor
        className={classNames(classes.editor, { [classes.hidden]: loading })}
        onChange={(val) => onChange(val)}
        value={value}
        customConfig={config(customConfig)}
        ref={editorRef}
        onBeforeLoadProp={() => handleLoaded()}
        disabled={disabled}
        rounded={rounded}
        type={borderless && 'borderless'}
      />
    </Box>
  );
};

RichTextEditorInputField.defaultProps = {
  className: '',
  onChange: noop,
  onLoaded: noop,
  disabled: false,
  rounded: false,
  customConfig: {},
  borderless: false,
};

RichTextEditorInputField.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onLoaded: PropTypes.func,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  rounded: PropTypes.bool,
  customConfig: PropTypes.object,
  borderless: PropTypes.bool,
};

export { RichTextEditorInputField };
